var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIconTxtUnderline(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    "data-name": "Layer 1",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 63.68 69.05",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "ng2Ssd"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M47.92,51.09l-2.59-7.31-1.79-4.49-4.49,0H24L19.76,51.19h-9c.29-.94.5-1.79.81-2.59L29.79.21,32.38.1l5.51.11S50.66,34,56.1,48.41c.31.84.61,1.69.95,2.62m-23-39.34-.58.09c-2.33,6.74-4.67,13.47-7,20.35H41.21C38.78,25.17,36.44,18.43,34.09,11.69Z",
    transform: "translate(-0.09 -0.1)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M63.77,61.46v7.69H.09V61.46Z",
    transform: "translate(-0.09 -0.1)"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconTxtUnderline);
export default __webpack_public_path__ + "static/media/icon_txt_Underline.6ce5b416f65bab6332cd361d5fccc8ea.svg";
export { ForwardRef as ReactComponent };